import { FC, useEffect, useState } from 'react';

import { useParams } from 'react-router';
import { AVAILABLE_ARTICLES, IPropsArticle } from '../../common/articles';
import { useAppDispatch } from '../../redux/store';
import { ErrorState } from '../../redux/AppReducer';
import { AppActions } from '../../redux/AppActions';
import { serverError } from '../../common/constants';
import { ArticleComponent } from '../../components/articles';
const ArticlesPage: FC = () => {
	const dispatch = useAppDispatch();
	const { articleId } = useParams();
	const [selectedArticle, setSelectedArticle] = useState<IPropsArticle | undefined>(undefined);
	const handleError = (error: ErrorState) => dispatch(AppActions.setGeneralError(error));
	useEffect(() => {
		if (articleId !== undefined) {
			let article = AVAILABLE_ARTICLES.find(article => article.id === articleId);
			if (article) {
				setSelectedArticle(article);
			} else {
				handleError(serverError);
			}
		}
	}, []);

	return <>{selectedArticle && <ArticleComponent article={selectedArticle} />}</>;
};

export default ArticlesPage;
